import styled from 'styled-components';
import { colors, layout, media } from '@prisjakt/ui-base';
import MegaphoneIcon from 'mdi-react/MegaphoneIcon';

export const MegaphoneIconDesktop = styled(MegaphoneIcon).attrs({ size: 24 })`
  ${media.mediumDown`
    display: none;
  `}
`;
export const MegaphoneIconMobile = styled(MegaphoneIcon).attrs({ size: 48 })`
  ${media.largeUp`
    display: none;
  `}
`;

export const PeakIndex = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: ${layout.measurements.fontSizeSmall};
  ${media.mediumDown`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    text-align: left;
    font-size: ${layout.measurements.fontSizeSmall};
    background-color: ${colors.semiWhite};
    border-radius: 8px;
    max-width: 640px;
  `}
`;

export const Icon = styled.div`
  ${media.mediumDown`
    display: flex;
    align-items: center;
    justify-content: center;
  `}
  min-width: 75px;
  ${media.smallOnly`
    min-width: 50px;
    svg {
      max-width: 32px;
    }
  `}
`;
export const Description = styled.div`
  margin-bottom: 8px;
  ${media.mediumDown`
    display: flex;
    align-items: center;
    margin: 8px 0;
  `}
`;
export const PriceChange = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${layout.measurements.fontSizeNormal};
  font-weight: 600;
  background-color: ${colors.semiWhite};
  border-radius: 8px;
  padding: 1rem;
  svg {
    margin-right: 4px;
  }
  ${media.smallOnly`
    font-size: ${layout.measurements.fontSizeNormal};
    svg {
      min-width: 24px;
    }
  `}
`;
